import type { JSX } from '@builder.io/qwik';
import { component$ } from '@builder.io/qwik';
import type { AdBlockInterface } from '~/types/AppData/PageBuilder/AdBlockInterface';

export default component$<AdBlockInterface['props']>(({ id }): JSX.Element => {
  return (
    <div
      id={id}
      class='flex justify-center items-center mx-auto h-[50px] w-[320px] md:h-[250px] md:w-[768px] lg:w-[970px]'
    />
  );
});
